import React from 'react';
import RoadmapTimeline from './components/RoadmapTimeline';

export default function CyberGRCRoadmapDisplay({ roadmap, maxMonth, isUnlocked, roleKey }) {
  return (
    <RoadmapTimeline
      roadmap={roadmap}
      title={`Your ${roadmap?.totalMonths || 6}-Month Cyber GRC Career Roadmap`}
      subtitle="Governance, Risk & Compliance Journey"
      maxMonth={maxMonth}
      isUnlocked={isUnlocked}
      fileName="tekyu-cybergrc-roadmap.pdf"
      roleKey={roleKey || "cybergrc"}
    />
  );
}

